import type { ReactNode } from 'react';

import type { TRecommendedPostsElement } from '@shared/dream-components';
import { RecommendedPostsElement } from '@shared/dream-components';

import { usePostPageContext } from '~/context/usePostPageContext';

interface Props {
  node: TRecommendedPostsElement;
  children: ReactNode | ReactNode[];
}

const RecommendedPosts = ({ node, children }: Props) => {
  const { showRecommendedPostsNode } = usePostPageContext() || {};

  if (!showRecommendedPostsNode) {
    return null;
  }

  return <RecommendedPostsElement element={node}>{children}</RecommendedPostsElement>;
};

export default RecommendedPosts;
